import {Mapper} from '@s-ui/domain'

/**
 * @export
 * @class FromQueryParamsToPageNameValueObjectPageMapper
 * @extends {Mapper}
 */
export default class FromQueryParamsToPageNameValueObjectPageMapper extends Mapper {
  /**
   * @constructor
   * @param {Config} config
   * @param {PageNameValueObject} valueObject
   */
  constructor({valueObject, config, pathToRegexp}) {
    super({valueObject, config, pathToRegexp})

    this._valueObject = valueObject
    this._config = config
    this._pathToRegexp = pathToRegexp
    this._pagePatterns = this._config.get('page').PAGE_PATTERNS
    this._homeNewsPattern = this._config.get('page').NEWS_HOME_PATH_PATTERN
    this._technicalDetailsSearchPathPattern = this._config.get('page').TECHNICAL_DETAILS_SEARCH_PATH_PATTERN
    this._paramsRegex = /[?].*$/g
  }

  /**
   * Return the current path without any params if we are not in news home,
   * else we return the news home w/ the query
   * @return {String}
   */
  _parsePath = ({path}) => {
    const cleanedPath = path.replace(this._paramsRegex, '')
    const isNewsHomePage = cleanedPath === this._homeNewsPattern
    const isTechnicalDetailsSearchPage = cleanedPath === this._technicalDetailsSearchPathPattern
    return !isNewsHomePage && !isTechnicalDetailsSearchPage ? cleanedPath : path
  }

  /**
   * Check current path matches pathPattern
   * @return {Boolean}
   */
  _checkPath = (pathPattern, path) => this._pathToRegexp(pathPattern).test(path)

  /**
   * Get page name for current path. If doesnt find any, return undefined
   * @return {String}
   */
  _getPageName = path => {
    const pageName = Object.keys(this._pagePatterns).find(key =>
      this._pagePatterns[key].some(pattern => this._checkPath(pattern, path))
    )
    return pageName
  }

  /**
   * @return {Object}
   */
  map = ({path}) => {
    const parsedPath = this._parsePath({path})
    const pageName = this._getPageName(parsedPath)
    return this._valueObject({pageName})
  }
}
